var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c(
        "div",
        { staticClass: "content-row content-align-center font-18 risks-head" },
        [
          _c("div", { staticClass: "hasrisk-icon" }),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("detection"))),
            _c(
              "span",
              {
                staticClass: "font-20",
                staticStyle: { margin: "0 .5rem", color: "#fe5b3f" }
              },
              [_vm._v(_vm._s(_vm.tips.riskCount))]
            ),
            _vm._v(_vm._s(_vm.$t("item")))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.riskLevelList.length === 0
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "content-row content-row-column content-align-center content-row-center",
                staticStyle: {
                  "padding-top": ".5rem",
                  "padding-bottom": ".7rem",
                  background: "#fff",
                  "border-bottom": ".5rem solid #f4f4f4"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "font-16",
                    staticStyle: { width: "91%", color: "#2cafff" }
                  },
                  [_vm._v(_vm._s(_vm.$t("noHeightRisk")))]
                )
              ]
            )
          ])
        : _c(
            "div",
            [
              _c("Symp_item", {
                attrs: {
                  riskLevelList: _vm.riskLevelList,
                  tips: _vm.tips,
                  classleve: _vm.classleve,
                  mClass: _vm.mClass,
                  nClass: false,
                  isShow: true,
                  hClass: _vm.hClass
                },
                on: { setModalInfo: _vm.setModalInfo }
              })
            ],
            1
          )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "margin-bottom": ".7rem" } },
      [
        _c(
          "div",
          {
            staticClass: "content-row content-align-center font-18 risks-head"
          },
          [
            _c("div", { staticClass: "norisk-icon" }),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("otherDetecation")))])
          ]
        ),
        _vm._v(" "),
        _vm.severeRisks.length != 0
          ? _c(
              "span",
              [
                _c("Symp_item", {
                  attrs: {
                    riskLevelList: _vm.mildRisks,
                    tips: _vm.mtips,
                    classleve: _vm.classleve,
                    mClass: true,
                    nClass: false,
                    isShow: _vm.isShow,
                    hClass: false
                  },
                  on: { setModalInfo: _vm.setModalInfo }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("Symp_item", {
          attrs: {
            riskLevelList: _vm.normalRisks,
            tips: _vm.ntips,
            classleve: _vm.classleve,
            mClass: false,
            nClass: true,
            isShow: true,
            hClass: false
          },
          on: { setModalInfo: _vm.setModalInfo }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          padding: ".75rem .3rem",
          background: "#fff",
          "margin-bottom": "50px"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "content-row content-row-column",
            staticStyle: {
              border: "1px solid #cbcbcb",
              "border-radius": ".7rem",
              overflow: "hidden"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "content-row content-row-between",
                staticStyle: { background: "#e5e5e5" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-align-center content-row-center",
                    staticStyle: { "flex-shrink": "1" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "level-box level-mild font-12",
                        staticStyle: { "margin-right": ".3rem" }
                      },
                      [_vm._v(_vm._s(_vm.$t("potentialRisk")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "split-line",
                  staticStyle: { "flex-shrink": "0" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-align-center content-row-center",
                    staticStyle: { "flex-shrink": "1" }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "level-box level-severe font-12" },
                      [_vm._v(_vm._s(_vm.$t("heightRisk")))]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content-row content-row-between" }, [
              _c(
                "div",
                {
                  staticClass: "content-row font-14",
                  staticStyle: {
                    padding: ".5rem",
                    "line-height": "1rem",
                    color: "#757575",
                    "flex-shrink": "1"
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("suggest")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "split-line",
                staticStyle: { "flex-shrink": "0" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content-row font-14",
                  staticStyle: {
                    padding: ".5rem",
                    "line-height": "1rem",
                    color: "#757575",
                    "flex-shrink": "1"
                  }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("suggestSolve")) +
                      "\n            "
                  )
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b56ebd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b56ebd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_symp.vue
// module id = null
// module chunks = 